import React from 'react'

export default function IcoCalendar( props ) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      { ...props }
    >
      <rect
        height="15"
        rx="2.5"
        width="17"
        x="3.5"
        y="5"
      />
      <path d="M3.5 9.5h17M8 3v4M16 3v4" />
    </svg>
  )
}
